var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 20,
    id: "img5",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNSAxOS43MTEzQzkuMTkwNiAxOS44OSA4LjgwOTQgMTkuODkgOC41IDE5LjcxMTNMMC44Mzk3NDQgMTUuMjg4N0MwLjUzMDM0NCAxNS4xMSAwLjMzOTc0NCAxNC43Nzk5IDAuMzM5NzQ0IDE0LjQyMjdMMC4zMzk3NDMgNS41NzczNUMwLjMzOTc0MyA1LjIyMDA5IDAuNTMwMzQzIDQuODg5OTYgMC44Mzk3NDMgNC43MTEzM0w4LjUgMC4yODg2NzZDOC44MDk0IDAuMTEwMDQzIDkuMTkwNiAwLjExMDA0MyA5LjUgMC4yODg2NzZMMTcuMTYwMyA0LjcxMTMyQzE3LjQ2OTcgNC44ODk5NiAxNy42NjAzIDUuMjIwMDkgMTcuNjYwMyA1LjU3NzM1TDE3LjY2MDMgMTQuNDIyNkMxNy42NjAzIDE0Ljc3OTkgMTcuNDY5NyAxNS4xMSAxNy4xNjAzIDE1LjI4ODdMOS41IDE5LjcxMTNaIiBmaWxsPSIjQTkwODIxIi8+Cjwvc3ZnPgo="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff;stroke: #81818c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14 27.5c-7.5 0-13.5-6-13.5-13.5c0-7.5 6-13.5 13.5-13.5c7.5 0 13.5 6 13.5 13.5c0 7.5-6 13.5-13.5 13.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Polygon 5",
    href: "#img5",
    transform: "matrix(1,0,0,1,5,4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLog);
export default __webpack_public_path__ + "static/media/RiskLog.e6854bc6.svg";
export { ForwardRef as ReactComponent };